// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","532":"styles","883":"component---src-pages-404-js"}[chunkId] + "-" + {"230":"48e6848e5e94023b1854","532":"684aba38cd781dfc6b61","883":"001321aa5d36d6684ae5"}[chunkId] + ".js";
};